import { IonIcon, IonInput, IonItem, IonLabel, IonNote } from '@ionic/react'
import { searchSharp } from 'ionicons/icons'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useStepsContext } from '../../context/StepsContext'
import useInput from '../../hooks/useInput'
import { COMPLETE_INPUT } from '../../redux/actions'

interface Props {
  label: string
  inputName: string
  inputMode?: 'search' | 'text' | 'tel' | 'none' | 'numeric' | 'url' | 'email' | 'decimal'
  disabled?: boolean
  hidden?: boolean
  minChar?: number
  maxChar?: number
  placeholder?: string
  note?: string
  largeNote?: boolean
  storeForm: string
  inputsPosition: 'stacked' | 'fixed' | 'floating' | undefined
  imageText?: string
  imageSrc?: string
  optional?: boolean
  searchInput?: boolean
  searchFunction?: (param: string) => {}
  clearFunction?: () => {}
}

const InputForm = ({
  label,
  inputName,
  inputMode,
  disabled,
  hidden,
  minChar,
  maxChar,
  placeholder,
  note,
  largeNote,
  storeForm,
  inputsPosition,
  imageText,
  imageSrc,
  optional,
  searchInput,
  searchFunction,
  clearFunction
}: Props) => {
  const { setClearSearch, clearSearch }: any = useStepsContext()
  const { reduxInput, input, error, itemRef, setInput, handleError, handleInput, clearError, validity } = useInput(
    inputName,
    storeForm,
    undefined,
    optional,
    disabled
  )
  const [recentlyMounted, setRecentlyMounted] = useState(true)
  const dispatch = useDispatch()

  useEffect(() => {
    if (validity)
      dispatch({
        type: COMPLETE_INPUT,
        payload: { name: inputName, value: input.trim(), storeForm }
      })
    else if (!recentlyMounted)
      dispatch({
        type: COMPLETE_INPUT,
        payload: { name: inputName, value: '', storeForm }
      })
    setRecentlyMounted(false)
  }, [validity, input])

  const search = () => {
    if (!input) return
    setClearSearch(!clearSearch)
    searchFunction?.(input)
  }

  const clear = () => {
    if (clearFunction) {
      clearFunction()
      setClearSearch(!clearSearch)
    }
  }

  useEffect(() => {
    if (location.href.includes('prospecto')) setInput('')
  }, [location.href])

  return (
    <div key={`inner-${label}`} hidden={hidden}>
      {imageSrc && (
        <div className="input-help">
          <span className="input-help-text">{imageText}</span>
          <img alt="help" src={imageSrc} />
        </div>
      )}
      <IonItem key={`uuid-${label}`} id={`${label}-id`} disabled={disabled} shape="round" ref={itemRef}>
        <IonLabel position={inputsPosition}>{label}</IonLabel>
        <IonInput
          key={`${label}-uuid`}
          id={`${label}-input`}
          type="text"
          placeholder={placeholder}
          inputMode={inputMode ?? undefined}
          autocomplete="off"
          minlength={minChar}
          maxlength={maxChar}
          name={inputName}
          value={input || reduxInput}
          onIonChange={handleInput}
          onIonFocus={clearError}
          onIonBlur={(e) => {
            handleError()
            searchInput && search()
          }}
          onClick={clear}
          required
        ></IonInput>
        {searchInput && <IonIcon className="input-searchIcon" slot="end" icon={searchSharp} onClick={search} />}
      </IonItem>
      {!error && note ? (
        <IonNote className={`input-info ${largeNote && 'large-note'}`}>{note}</IonNote>
      ) : (
        !disabled && <span className={`${largeNote && 'large-note'} input-error`}>{error}</span>
      )}
    </div>
  )
}

export default InputForm
